import { Point } from "./Point";
import { Distance } from "./Geometry";
import { exists } from "./utils";

export class Rectangle {

    public Right:number;
    public Left:number;
    public Top:number;
    public Bottom:number;

    public Height:number;
    public Width:number;
    public P1:Point;
    public P2:Point;
    
    private constructor(p1:Point, p2:Point){
        if(!p1){
            console.error("P1 is bad");
        }
        if(!p2){
            console.error("P2 is bad");
        }
        this.P1=p1;
        this.P2=p2;
        this.Right=Math.max(p1.X, p2.X);
        this.Left=Math.min(p1.X, p2.X);
        this.Top=Math.max(p1.Y, p2.Y);
        this.Bottom=Math.min(p1.Y, p2.Y);

        this.Height=Distance(this.Top, this.Bottom);
        this.Width=Distance(this.Left, this.Right);
    }
    public static build_from_arrays(p1:number[], p2:number[]): Rectangle
    {
        let p1p:Point = Point.build_from_array(p1);
        let p2p:Point = Point.build_from_array(p2);
        if(!exists(p1p)){
            return null;
        }
        if(!exists(p2p)){
            return null;
        }
        return new Rectangle(p1p, p2p);
    }

    public static build_from_array(p1p2:any[]): Rectangle
    {
        return Rectangle.build_from_numbers(p1p2[0][0], p1p2[0][1], p1p2[1][0], p1p2[1][1]);
    }

    public static build(p1:Point, p2:Point): Rectangle
    {
        if(p1 instanceof Point){
            if(p2 instanceof Point){
                return new Rectangle(p1, p2);
            }
        }
        //console.error('malformed Rectangle(' + p1 + ', ' + p2 + ')')        
        return null;
    }
    public static build_from_numbers(p1x:number,p1y:number, p2x:number, p2y:number): Rectangle
    {
        return Rectangle.build(Point.build(p1x, p1y), Point.build(p2x, p2y));
    }
    public toString():string{
        return this.as_string;
    }
    public get as_string():string{
        return JSON.stringify(this.as_json);
    }

    public get as_array():number[][]{
        if (!this.P1.toArray()[0]){
            console.debug("Rectangle has null P1 ");
            return null;
        }
        return [this.P1.toArray(), this.P2.toArray()];

    }
    public toArray():number[][]{
        return this.as_array;
    }

    public get as_json():any{
        return this.as_array;
    }

    public toJSON():any{
        return this.toArray();
    }

    public get Hypotenuse():number{
        return Math.sqrt(this.Width*this.Width+this.Height*this.Height);
    }
    public static NULL:Rectangle = new Rectangle(Point.NULL, Point.NULL);
}

